import React, { useEffect, useState } from 'react';
import { Button, ButtonGroup, Card, Col, Container, Dropdown, Form, OverlayTrigger, Row, Tooltip } from 'react-bootstrap';
import { DndContext, closestCenter, PointerSensor, useSensor, useSensors, useDroppable, DragOverlay } from '@dnd-kit/core';
import { SortableContext, verticalListSortingStrategy, useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import { useDispatch, useSelector } from 'react-redux';
import { getSubFormKanbanListStart, getSubFormListByIdStart, updateSubFormByIdStart } from '../../../Store/Slices/subFormSlice';
import { formatSimpleDate } from '../../../Components/DateFn';
import { GoDotFill, GoPlusCircle } from 'react-icons/go';
import { BsArrowsCollapseVertical, BsArrowsExpandVertical } from 'react-icons/bs';
import { useNavigate } from 'react-router-dom';
import { Utils } from '../../../Utils';

const KanbanCard = ({ card, listeners, onCardSelect, isSelected, selectedCards, createAssignmentData, title, _id, id, subFormData, subFormId,
    basicPermissionData, currencyCode
}) => {
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];
    const navigate = useNavigate();
    const today = new Date();
    const inputDate = new Date(card?.Closing_Date);
    const isPast = inputDate < today.setHours(0, 0, 0, 0);


    function checkExistingFormat(value) {
        if (typeof value === 'number') return formatNumber(value);
        if (typeof value !== 'string') return value;
        const str = value.trim();
        const isPlainNumber = /^[0-9]+(\.[0-9]+)?$/.test(str);
        return isPlainNumber ? formatNumber(parseFloat(str)) : value;
    }

    const formatNumber = (amount) => {
        return new Intl.NumberFormat(currentCurrencyData?.digit_format, {
            style: "decimal",
            minimumFractionDigits: currentCurrencyData?.decimal_place,
            maximumFractionDigits: currentCurrencyData?.decimal_place,
        }).format(amount);
    };
    console.log('card in kanban', card);
    return (
        <Card className={`kanban-column-data shadow-sm p-0 ${isSelected && 'card-selected border-primary'}`} style={{ marginBottom: 8, minWidth: 'auto', width: 'auto' }}>
            <Card.Body className='py-2'>
                <Form.Check type="checkbox" className='checkbox fs-6 border-secondary position-absolute end-0 translate-middle-x'
                    style={{ top: '0.5rem' }}
                    checked={isSelected}
                    onChange={(e) => onCardSelect(card._id, e?.target?.checked)}
                />
                {/* <div> */}
                <div className='fw-semibold user-name cursor-pointer'
                    onClick={() => navigate(Utils.getNavigationUrl(`form-module/Deals/${_id}`), {
                        state: {
                            moduleName: "Deals",
                            card: card,
                            subFormData: subFormData,
                            id: id,
                            basicPermissionData: basicPermissionData
                        }
                    })}
                >{card.Deal_Name}</div>
                <div  {...listeners} style={{ cursor: 'grab' }}>
                    <div className='user-name'>{card.Account_Name.name}</div>
                    <div className='user-name'>{card.Deal_Owner.name}</div>
                    <div className='user-name'>{currencyCode} {checkExistingFormat(card.Amount)}</div>
                    {/* <div className='user-name'
                        style={{
                            color: card?.Status === 'In Approval' ? '#B8860B' :
                                card?.Status === 'Rejected' ? 'red' :
                                    'green',
                        }}
                    >{card?.Status}</div> */}
                    {title === 'Closed Won' || title === 'Closed Lost' || title === 'Closed Lost to Competition' ?
                        <div className='closing-date'>{formatSimpleDate(card.Closing_Date)}</div>
                        : <div className='closing-date' style={{ color: isPast && "#FF5D5A" }}>{formatSimpleDate(card.Closing_Date)}</div>
                    }
                </div>
                {/* </div> */}
                <Dropdown className='position-absolute end-0' style={{ bottom: '0.5rem' }}>
                    <Dropdown.Toggle variant="link" className='p-0 w-30px h-30px'>
                        <GoPlusCircle size={20} className='text-primary' />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                        <Dropdown.Item
                            onClick={() => createAssignmentData(card._id, "Tasks")}
                        >Create Task</Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => createAssignmentData(card._id, "Meetings")}
                        >Create Meeting</Dropdown.Item>
                        <Dropdown.Item
                            onClick={() => createAssignmentData(card._id, "Calls")}
                        >Create Call</Dropdown.Item>
                    </Dropdown.Menu>
                </Dropdown>
            </Card.Body>
        </Card >
    );
};

const SortableKanbanCard = ({ card, onCardSelect, isSelected, selectedCards, createAssignmentData, title, id, subFormData, subFormId,
    basicPermissionData, currencyCode
}) => {
    const { attributes, listeners, setNodeRef, transform, transition, isDragging } = useSortable({ id: card._id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: isDragging ? 0.5 : 1,
        marginBottom: 8,
        minWidth: 'auto',
        width: 'auto'
    };

    return (
        <div ref={setNodeRef} {...attributes} style={style}>
            <KanbanCard card={card}
                listeners={listeners}
                onCardSelect={onCardSelect} isSelected={isSelected}
                selectedCards={selectedCards} createAssignmentData={createAssignmentData}
                title={title}
                _id={card._id}
                id={id}
                subFormData={subFormData}
                subFormId={subFormId}
                basicPermissionData={basicPermissionData}
                currencyCode={currencyCode}
            />
        </div>
    );
};

// Column with droppable logic
// const KanbanColumn = ({ cards, children, title, percentage, amount }) => {
const KanbanColumn = ({ columnId, id, title, percentage, amount, cards, isCollapsed, toggleCollapse, onCardSelect, selectedCards,
    createAssignmentData, activeId, subFormData, subFormId, basicPermissionData, currencyCode
}) => {
    const navigate = useNavigate()
    // const { setNodeRef, isOver } = useDroppable({ id: title });
    const { setNodeRef, isOver } = useDroppable({ id: `column-${columnId}` });

    return (
        <div ref={setNodeRef}
            // className={`kanban-column me-1 ${isCollapsed ? 'kanban-board-collapsed' : ''}
            //  ${title === 'Proposal/Price Quote' ? 'kv-lime-green' :
            //         title === 'Negotiation/Review' ? 'kv-light-red' :
            //             'kv-light-green'
            //     }`}>
            className={`kanban-column me-1 ${isCollapsed ? 'kanban-board-collapsed' : ''}
             ${title === 'Closed Won' ? 'kv-won' :
                    title === 'Closed Lost' || title === 'Closed Lost to Competition' ? 'kv-lost' :
                        'kv-normal'
                }
                ${isOver ? 'kanban-column-highlight' : ''}`}>
            <Card className="h-100 p-0 border-0 bg-transparent rounded-0 shadow-none">
                {!isCollapsed && (<>
                    <Card.Header className="kanban-column-header">
                        <div className="hstack gap-2">
                            <span className='fw-medium'>{title}</span>
                            <span className='badge w-20px h-20px hstack justify-content-center rounded-circle fw-medium text-dark cards-count-bg'>
                                {cards.length}
                            </span>
                            <GoDotFill size={14} className='text-secondary' />
                            <span>{percentage}%</span>
                        </div>
                        <div className='fw-medium'>{currencyCode} {amount}</div>
                    </Card.Header>
                    <Card.Body className={`kanban-column-body p-0 pt-2 overflow-y-auto`}
                        style={{
                            maxHeight: 'calc(100vh - 270px)',
                            transition: 'background 0.2s',
                            background: isOver ? '#e8f5ff' : 'transparent'
                        }}>
                        <SortableContext items={cards.map(c => c._id)} strategy={verticalListSortingStrategy}>
                            {cards.map(card =>
                                <SortableKanbanCard
                                    key={card._id}
                                    card={card}
                                    onCardSelect={onCardSelect}
                                    isSelected={selectedCards.includes(card._id)}
                                    selectedCards={selectedCards}
                                    createAssignmentData={createAssignmentData}
                                    title={title}
                                    id={id}
                                    subFormData={subFormData}
                                    subFormId={subFormId}
                                    basicPermissionData={basicPermissionData}
                                    currencyCode={currencyCode}
                                />
                            )}
                        </SortableContext>
                        {cards.length === 0 && <div className="text-center text-muted py-4">Drop cards here</div>}
                    </Card.Body>
                    <Card.Footer className='kanban-column-footer shadow-top border-top rounded-0 p-0'>
                        <ButtonGroup aria-label='footer btn' className='w-100 rounded-0'>
                            <Button variant="outline-primary-white border-0 me-0 py-2 rounded-top-0"
                                // onClick={() => navigate(Utils.getNavigationUrl(`form-module/sub-form/create/${id}`))}
                                onClick={() => navigate(Utils.getNavigationUrl(`form-module/sub-form/create/${id}`), { state: { DealName: title } })}
                            >
                                Create Deal</Button>
                            <OverlayTrigger delay={300} overlay={<Tooltip id={`${title}-collapse-tooltip`}>Collapse Kanban Stage</Tooltip>}>
                                <Button variant="outline-primary-white border-0 border-start me-0 py-2 rounded-top-0"
                                    onClick={toggleCollapse}
                                >
                                    <BsArrowsCollapseVertical size={18} />
                                </Button>
                            </OverlayTrigger>
                        </ButtonGroup>
                    </Card.Footer>
                </>)}
                {isCollapsed && (
                    <Card className={`h-100 pt-0 px-3 pb-2 shadow-sm border-top-3`}
                        onClick={toggleCollapse}>
                        <div className="hstack gap-2 kanban-collapse-vertical">
                            <span className='badge text-dark fw-medium fs-14 rounded-3 border vertical-title-bg'>{title}</span>
                            <span className='badge bg-secondary-subtle text-dark fw-medium px-0 h-20px rounded-circle my-auto'
                                style={{ minWidth: 20 }}>
                                {cards.length}
                            </span>
                            <span className='text-body-tertiary'><GoDotFill size={14} /></span>
                            <span>{percentage}%</span>
                            <div className='fw-semibold'>{currencyCode} {amount}</div>
                        </div>
                        <OverlayTrigger delay={300} overlay={<Tooltip id={`${title}-collapse-tooltip`}>Expand Kanban Stage</Tooltip>}>
                            <Button variant="outline-primary-white border-0 border-start me-0 py-2 rounded-top-0 collapse-btn">
                                <BsArrowsExpandVertical size={18} />
                            </Button>
                        </OverlayTrigger>
                    </Card>
                )}
            </Card>
        </div>
    );
};

const KanbanBoard = ({ id, stageProbability, createAssignmentData,
    setOwnerChangeModal, setSendEmail, setSelectedRowData,
    basicPermissionData, setPermissionDenied, setRemoveModalData }) => {
    let currentCurrencyData = useSelector((state) => state?.currency)?.data?.[0];
    const dispatch = useDispatch();
    let subFormData = useSelector((state) => (state?.subForm || ''));
    const formsubmodules = useSelector((state) => state?.subForm);
    const stages = stageProbability;

    const [collapsedColumns, setCollapsedColumns] = useState({});
    const [selectedCards, setSelectedCards] = useState([]);
    const [subFormlayoutList, setSubFormlayoutList] = useState([]);
    let [sortBy, setSortBy] = useState('');
    let [sortOrder, setSortOrder] = useState();
    let [subFormId, setSubFormId] = useState();
    let [destinationStage, setDestinationStage] = useState()
    let [destinationProb, setDestinationProb] = useState()
    let [isCallAPI, setIsCallAPI] = useState(false)
    const [activeId, setActiveId] = useState(null)

    const toggleCollapse = (columnIndex) => {
        setCollapsedColumns(prev => ({
            ...prev,
            [columnIndex]: !prev[columnIndex],
        }));
    };

    const handleCardSelect = (cardId, isChecked) => {
        if (isChecked) {
            setSelectedCards([cardId])
        } else {
            setSelectedCards([]);
        }
        // setSelectedCards(prev => {
        //     if (prev.includes(cardId)) {
        //         return prev.filter(id => id !== cardId);
        //     } else {
        //         return [...prev, cardId];
        //     }
        // });
    };

    const hasSelectedCards = selectedCards.length === 1;

    const sensors = useSensors(useSensor(PointerSensor));

    useEffect(() => {
        if (id) dispatch(getSubFormKanbanListStart({ id }));
    }, [id]);

    useEffect(() => {
        let subFormDatas = formsubmodules?.kanbanData?.formsubmodules;
        if (subFormDatas?.length > 0 && id) {
            let processedData = subFormDatas.map(item => ({
                _id: item?._id,
                ...[...item.data].reduce((acc, curr) => ({ ...acc, ...curr.section_data }), {}),
                User_Name: item?.userId?.firstName ? (item?.userId?.firstName + ' ' + item?.userId?.lastName) : '_',
                SAP_Status: (item.sapResponse?.sapStatus || '_'),
                SAP_Message: (item.sapResponse?.sapMsg || '_'),
                Status: item.status || '_',
                createdAt: item.createdAt || '_',
                updatedAt: item.updatedAt || '_',
                createdBy: item.userId || '_',
                updatedBy: item.updatedBy || '_'
            }));
            setSubFormlayoutList(processedData);
        } else setSubFormlayoutList([]);
    }, [formsubmodules?.kanbanData?.formsubmodules]);

    // Group cards by stage
    const groupedData = subFormlayoutList.reduce((acc, deal) => {
        const stageName = stages?.find(s => s.id === Number(deal.Stage))?.stageName || 'Unknown';
        if (!acc[stageName]) acc[stageName] = [];
        acc[stageName].push(deal);
        return acc;
    }, {});

    const groupedData1 = subFormlayoutList.reduce((acc, deal) => {
        const stage = stages?.find(x => x?.id === Number(deal.Stage))?.stageName
        if (!acc[stage]) {
            acc[stage] = {
                id: stages?.find(x => x?.id === Number(deal.Stage))?.id ?? 0,
                title: stage,
                percentage: stages?.find(x => x?.id === Number(deal.Stage))?.probability ?? 0,
                cards: [],
                amount: 0
            };
        }

        const amount = parseFloat(
            String(deal.Amount).replace(/[^0-9.-]+/g, "")
        ) || 0;

        acc[stage].cards.push(deal);
        acc[stage].amount += amount;

        return acc;
    }, {});

    const stageOrder = stages?.map(s => s.stageName);

    const formatAmount = (value) => {
        if (!value) return "0.00";

        const num = parseFloat(String(value).replace(/,/g, "")) || 0;

        return new Intl.NumberFormat("en-US", {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(num);
    };

    const kanbanData = stageOrder?.map(stage => ({
        id: groupedData1[stage] ? String(groupedData1[stage]?.id) : String(stages?.find((item) => item?.stageName === stage)?.id),
        title: stage,
        cards: groupedData[stage] || [],
        amount: groupedData1?.[stage]?.amount ? formatAmount(groupedData1?.[stage]?.amount) : 0,
        percentage: groupedData1?.[stage]?.percentage || stages?.find((item) => item?.stageName === stage)?.probability
    }));

    // const handleDragEnd = (event) => {
    //     const { active, over } = event;
    //     if (!over) return;
    //     setSubFormId(active.id)
    //     const activeId = active.id;
    //     const destColumn = over.id;

    //     let sourceStage = '';
    //     let destStage = '';
    //     let destProbability = '';
    //     let destIndex = ''

    //     for (let col of kanbanData) {
    //         if (col.cards.some(c => c._id === activeId)) sourceStage = col.title;
    //         if (col.cards.some(c => c._id === destColumn) || col.title === destColumn) { destStage = col.title; destProbability = col.percentage; destIndex = col.id };
    //     }

    //     if (!sourceStage || !destStage) return;
    //     if (sourceStage === destStage) return;

    //     const card = groupedData[sourceStage].find(c => c._id === activeId);
    //     groupedData[sourceStage] = groupedData[sourceStage].filter(c => c._id !== activeId);
    //     if (!groupedData[destStage]) groupedData[destStage] = [];
    //     groupedData[destStage].push(card);

    //     // Update card Stage to match column
    //     card.Stage = stages?.find(s => s.stageName === destStage)?.id;

    //     setSubFormlayoutList(Object.values(groupedData).flat());

    //     if (activeId && id) {
    //         setIsCallAPI(true)
    //         setDestinationStage(destIndex)
    //         setDestinationProb(destProbability)
    //         // dispatch(getSubFormListByIdStart({
    //         //     moduleId: id,
    //         //     subModuleId: activeId
    //         // }));
    //     }
    // };

    const handleDragStart = (event) => {
        setActiveId(event.active.id);
    };

    const handleDragEnd = (event) => {
        setActiveId(null)
        const { active, over } = event;
        if (!over) return;

        const activeId = active.id;   // dragged card id
        const overId = over.id;       // could be 'column-<id>' OR a card id

        // find source & dest columns from kanbanData (metadata)
        const sourceCol = kanbanData.find(col => col.cards.some(c => c._id === activeId));
        if (!sourceCol) return;

        let destCol = null;
        // If dropped on a column wrapper (empty space)
        if (String(overId).startsWith('column-')) {
            const colId = String(overId).replace('column-', '');
            destCol = kanbanData.find(col => String(col.id) === String(colId));
        } else {
            // dropped on a card → destination is that card's column
            destCol = kanbanData.find(col => col.cards.some(c => c._id === overId));
        }

        // if (!destCol) return;
        if (!destCol || destCol.id === sourceCol.id) return;

        // no-op if same column and dropped on itself
        if (sourceCol.id === destCol.id && sourceCol.title === destCol.title) {
            // but we may still want to handle reorder within same column:
            // handle below
        }

        // create deep clone of groupedData so we don't mutate original
        const newGrouped = JSON.parse(JSON.stringify(groupedData));

        // Same column => reorder
        if (String(sourceCol.id) === String(destCol.id)) {
            const cards = [...(newGrouped[sourceCol.title] || [])];
            const oldIndex = cards.findIndex(c => c._id === activeId);
            // If overId is a column wrapper (i.e., dropped on empty space), skip reorder
            const newIndex = overId && !String(overId).startsWith('column-') ? cards.findIndex(c => c._id === overId) : -1;

            if (oldIndex !== -1 && newIndex !== -1 && oldIndex !== newIndex) {
                const [moved] = cards.splice(oldIndex, 1);
                cards.splice(newIndex, 0, moved);
                newGrouped[sourceCol.title] = cards;
                setSubFormlayoutList(Object.values(newGrouped).flat());
            }
            return;
        }

        // Cross-column move
        const card = sourceCol.cards.find(c => c._id === activeId);
        if (!card) return;

        // remove from source
        newGrouped[sourceCol.title] = (newGrouped[sourceCol.title] || []).filter(c => c._id !== activeId);

        // prepare destination array
        const destCards = [...(newGrouped[destCol.title] || [])];

        // if dropping on a specific card, insert at its position; otherwise push
        if (!String(overId).startsWith('column-')) {
            const overIndex = destCards.findIndex(c => c._id === overId);
            if (overIndex === -1) {
                destCards.push({ ...card, Stage: destCol.id });
            } else {
                destCards.splice(overIndex, 0, { ...card, Stage: destCol.id });
            }
        } else {
            // dropped onto empty column area
            destCards.push({ ...card, Stage: destCol.id });
        }

        newGrouped[destCol.title] = destCards;

        // update UI
        setSubFormlayoutList(Object.values(newGrouped).flat());

        // trigger API call to update stage
        setSubFormId(activeId);
        setIsCallAPI(true);
        setDestinationStage(destCol.id);
        setDestinationProb(destCol.percentage);
    };


    useEffect(() => {
        if (isCallAPI && subFormId && id && subFormData?.formsubmodules?.length > 0) {
            setIsCallAPI(false)
            // let isSubFormData =* subFormData?.formsubmodules?.[0]?.data;
            let isSubFormData = subFormData?.formsubmodules?.find((item) => item._id === subFormId)?.data
            let updateKeys = {
                formsubmodules: "formsubmodules",
                message: "message",
                exit: "exit",
                isLoading: "isLoading",
                status: "status",
                reload: "reload",
                error: "error"
            }

            let sections = isSubFormData?.map(section =>
                section.section_name === "Deal Information"
                    ? {
                        ...section,
                        section_data: {
                            ...section.section_data,
                            Stage: destinationStage,
                            Probability_: destinationProb
                        }
                    }
                    : section
            );

            const dealInfo = sections?.find(s => s?.section_name === "Deal Information");
            const dealOwnerId = dealInfo?.section_data?.Deal_Owner?._id;

            // let obj = {
            //     subModuleId: subFormId,
            //     payload: payload,
            //     updateKeys
            // }

            const mergedObject = sections.reduce((acc, curr) => {
                return { ...acc, ...curr.section_data };
            }, {});

            let payload = {
                audit_log: { msg: '' },
                data: sections,
                moduleId: id,
                userId: dealOwnerId,
                stage_history: mergedObject
            }
            dispatch(updateSubFormByIdStart({
                subModuleId: subFormId,
                payload: payload,
                updateKeys
            }));
        }
    }, [isCallAPI])
    // }, [subFormData])

    useEffect(() => {
        if (formsubmodules?.updateStatus && id) {
            setIsCallAPI(false)
            setSubFormId()
            if (id) dispatch(getSubFormKanbanListStart({ id }));
        }
    }, [formsubmodules?.updateStatus]);

    const handleSortBy = (e) => {
        setSortBy(e.target.value);
        if (!sortOrder) {
            setSortOrder('asc')
        }
    }

    const handleSortOrder = (e) => {
        setSortOrder(e.target.value);
    }

    useEffect(() => {
        if (sortBy && sortOrder) {
            let payload = {
                id, sortBy, sortOrder
            }
            dispatch(getSubFormKanbanListStart(payload));
        }
    }, [sortBy, sortOrder])

    return (
        <> <Row className="g-2 pt-1">
            <Col xs={12} md={6} className='hstack gap-2 mb-2 action-btns ps-3'>
                {hasSelectedCards && (<>
                    <Button variant='light border'
                        onClick={() => {
                            setSendEmail(true);
                            setSelectedRowData(kanbanData?.find((item) => item._id === selectedCards?.[0]))
                        }}
                    >Send Mail</Button>
                    {/* <Button variant='light border'>Create task</Button> */}
                    <Dropdown>
                        <Dropdown.Toggle variant="light border pe-2 with-arrow">
                            <span className='pe-4'>Actions</span>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                            <Dropdown.Item
                                onClick={() => {
                                    setOwnerChangeModal(selectedCards?.[0])
                                }}
                            >Change Owner</Dropdown.Item>
                            <Dropdown.Item
                                onClick={() =>
                                    !basicPermissionData?.some(
                                        (x) => x?.id === id && x.activities.delete === true
                                    )
                                        ? setPermissionDenied(true)
                                        : selectedCards?.[0]
                                            ? setRemoveModalData({
                                                subModuleId: selectedCards?.[0],
                                                payload: {
                                                    _id: selectedCards?.[0],
                                                    moduleId: formsubmodules.modules._id
                                                }
                                            })
                                            : console.error('rowId is undefined')
                                }
                            >Delete</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                </>)}
            </Col>
            <Col xs={12} md={6} className={`hstack gap-2 justify-content-end mb-2 pe-3 ${hasSelectedCards ? '' : 'ms-auto'}`}>
                <Form.Label className="col-auto col-form-label fw-normal">Sort By:</Form.Label>
                <Col className='col-auto'>
                    <select className="form-select" id="kanbanFilterTableHeaderName"
                        onChange={(e) => handleSortBy(e)}
                        value={sortBy}
                    >
                        <option value="" disabled selected>None</option>
                        <option value="Deal_Owner">Deal Owner</option>
                        <option value="Account_Name">Account Name</option>
                        <option value="Type">Type</option>
                        <option value="Lead_Source">Lead Source</option>
                        <option value="Deal_Name">Deal Name</option>
                        <option value="Closing_Date">Closing Date</option>
                        <option value="Probability_">Probability</option>
                        <option value="Contact_Name">Contact Name</option>
                        <option value="Amount">Amount</option>
                        <option value="Stage">Stage</option>
                        <option value="Expected_Revenue">Expected Revenue</option>
                    </select>
                </Col>
                <Col className='col-auto'>
                    <select className="form-select" id="kanbanFilterSortOrder"
                        onChange={(e) => handleSortOrder(e)}
                        value={sortOrder}
                    >
                        <option value="" disabled selected>None</option>
                        <option value="asc">Asc</option>
                        <option value="desc">Desc</option>
                    </select>
                </Col>
            </Col>
        </Row>
            <DndContext sensors={sensors} collisionDetection={closestCenter} onDragStart={handleDragStart} onDragEnd={handleDragEnd}>
                <Container fluid className="d-flex py-2 overflow-auto" style={{ height: '100%' }}>
                    {kanbanData?.map((column, idx) => (
                        <KanbanColumn
                            id={id}
                            subFormData={subFormData}
                            subFormId={subFormId}
                            // key={idx}
                            key={column.id}
                            columnId={column.id}
                            title={column.title}
                            percentage={column.percentage}
                            amount={column.amount}
                            cards={column.cards}
                            isCollapsed={collapsedColumns[idx]}
                            toggleCollapse={() => toggleCollapse(idx)}
                            onCardSelect={handleCardSelect}
                            selectedCards={selectedCards}
                            createAssignmentData={createAssignmentData}
                            basicPermissionData={basicPermissionData}
                            currencyCode={currentCurrencyData?.currency_code}
                        />
                        // <KanbanColumn
                        //     id={id}
                        //     key={inx}
                        //     cards={col.cards}
                        //     title={col.title}
                        //     percentage={col.percentage}
                        //     amount={col.amount} />
                    ))}
                </Container>
                <DragOverlay>
                    {activeId ? (
                        <KanbanCard
                            card={subFormlayoutList.find(c => c._id === activeId)}
                            onCardSelect={() => { }}
                            isSelected={false}
                            selectedCards={[]}
                            createAssignmentData={() => { }}
                            title=""
                        />
                    ) : null}
                </DragOverlay>
            </DndContext>
        </>
    );
};

export default KanbanBoard;
